import { render, staticRenderFns } from "./content-header.vue?vue&type=template&id=b3cc8eea&scoped=true&"
import script from "./content-header.vue?vue&type=script&lang=js&"
export * from "./content-header.vue?vue&type=script&lang=js&"
import style0 from "./content-header.vue?vue&type=style&index=0&id=b3cc8eea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cc8eea",
  null
  
)

export default component.exports